import { Component, OnInit, Input, Output, EventEmitter, AfterViewInit } from '@angular/core'
import { Router } from '@angular/router'
import { ActivatedRoute, Params } from '@angular/router'
import { EappBeneficiaryGateway } from '../gateways/EAppEnrollment-gateway'
import { BeneficiaryInfoBeneficiary } from '../models/enrollments-beneficiary'
import { UserProfile } from '../../user-management/models/user-profile'
import { EnrollmentFieldBeneficiary, EnrollmentFieldCodesBeneficiary } from '../models/enrollment-field-beneficiary'
import { EnrollmentViewModel } from '../models/enrollment-view-model'
import { PlanList } from '../models/plan-list'
import { ValidatedRadioButtonModel } from '../../validations/validated-radio-button-group.component'
import { NotBlankGenericFieldValidator } from '../../validations/not-blank-generic-field-validator'
import { DateTextFieldValidator } from '../../validations/date-text-field.validator'
import { BeneficiaryElectionPeriods } from '../models/beneficiary-election-periods'
import { EnrollmentElectionType } from '../models/enrollment-election-type'
import { BeneficiaryEnrollmentDataService } from '../gateways/beneficiary-enrollment-data-service'
import { PortalGlobals } from '../../portalglobals'
import { ValidatedSelectOptionModel } from '../../validations/validated-dropdown.component'
import { AccountTypes, PaymentAccount } from '../models/beneficiary-payment-account'
import * as moment from 'moment'
import { GenderPref } from '../../enrollment/models/gender-pref'
import { EnrollmentFieldCodes } from '../models/enrollment-field'

@Component({
    selector: 'EappVerifyStep2',
    templateUrl: 'e-app-verify-Step2.component.html',
    styleUrls: ['./EApp-beneficiary.component.scss']
})
export class EAppVerifyStep2Component implements OnInit, AfterViewInit {
    @Output() periodSelectdChanged: EventEmitter<string> = new EventEmitter<string>()

    periodSelected = ''
    reasonCode = '-1'

    private uniqueLink: string
    enrollmentViewModel: EnrollmentViewModel = new EnrollmentViewModel()
    electionPeriods: ValidatedRadioButtonModel[] = [] as ValidatedRadioButtonModel[]
    beneficiaryEnrollmentElectionTypes: EnrollmentElectionType[] = [] as EnrollmentElectionType[]
    electionOprionsByPeriod: ValidatedRadioButtonModel[] = [] as ValidatedRadioButtonModel[]
    selectedElectionTypes: EnrollmentElectionType[] = [] as EnrollmentElectionType[]
    enrollmentElectionTypes: EnrollmentElectionType[] = [] as EnrollmentElectionType[]
    genderOptions: ValidatedRadioButtonModel[] = [] as ValidatedRadioButtonModel[]
    titleOptions: ValidatedSelectOptionModel[] = [] as ValidatedSelectOptionModel[]
    eobOptions: ValidatedRadioButtonModel[] = [] as ValidatedRadioButtonModel[]
    paymentOptions: ValidatedRadioButtonModel[] = [] as ValidatedRadioButtonModel[]
    //enrollmentDrugViewModel: EnrollmentViewModel = {} as EnrollmentViewModel
    enrol: EnrollmentViewModel = {} as EnrollmentViewModel
    notBlankValidator: NotBlankGenericFieldValidator = new NotBlankGenericFieldValidator()
    optionrbPresDrug: ValidatedRadioButtonModel[] = []
    userProfileModel: UserProfile
    showUpdatesSettingsMessage = 'Success'
    optionrbLang: ValidatedRadioButtonModel[] = []

    @Input() enrollment: BeneficiaryInfoBeneficiary
    @Output() onValueChange: EventEmitter<BeneficiaryInfoBeneficiary> = new EventEmitter<BeneficiaryInfoBeneficiary>()

    disabled: boolean = false
    selectedOption = 'None'
    electedOptionCode = '0'
    onDate: string = '' // new Date().toJSON().slice(0, 10).replace(/-/g, '/')
    sepDate: string
    validatedDate = new DateTextFieldValidator()
    isDateField = false
    EnrollmentViewModel: EnrollmentViewModel
    planYear: number
    public optionrbPlan: ValidatedRadioButtonModel[] = []
    selPlan: string
    AppDate: Date
    planList: PlanList[] = [] as PlanList[]
    EffectiveDate: Date
    genderOption: string = ''
    emailLabel: string
    titleOption: string = ''
    eobOption: string = ''
    eobEmail: string = ''
    eobEmailLabel: string = ''
    paymentOption: string = ''
    showDet = false
    sameAsTopAddress: boolean
    agentId: number
    allStates: ValidatedSelectOptionModel[] = [] as ValidatedSelectOptionModel[]
    paymentAccount: PaymentAccount = {} as PaymentAccount
    loading: boolean = false
    orgName: string
    public insurance: string
    PaperlessSelected: boolean = false
    accessibilityValue: string
    visibleFrom2025: boolean
    iscurrentGenderOther: boolean
    isyourSelfOther: boolean
    optionaccessibility: ValidatedRadioButtonModel[] = []
    currentGenderOptions: ValidatedRadioButtonModel[] = [] as ValidatedRadioButtonModel[]
    repYourSelfOptions: ValidatedRadioButtonModel[] = [] as ValidatedRadioButtonModel[]
    currentGender: GenderPref[] = [] as GenderPref[]
    repYourSelf: GenderPref[] = [] as GenderPref[]

    accountInfoFormIsVisible() {
        return this.paymentOption === 'Automatic Bank Draft Withdrawal'
    }

    accountTypeOptions: ValidatedRadioButtonModel[] = Object.keys(AccountTypes).map((accountTypeKey) => {
        return { value: accountTypeKey, htmlLabel: AccountTypes[accountTypeKey] }
    })

    constructor(
        private _router: Router,
        private route: ActivatedRoute,
        private _enrollmentGateway: EappBeneficiaryGateway,
        private selElectionPeriod: BeneficiaryEnrollmentDataService,
        public _global: PortalGlobals,
        private enrollmentdata: BeneficiaryEnrollmentDataService
    ) {
        this.optionrbPresDrug.push({ value: 'yes', htmlLabel: 'Yes' }, { value: 'no', htmlLabel: 'No' })

        this.userProfileModel = {} as UserProfile
        this.optionrbLang.push(
            { value: 'English', htmlLabel: 'English', disabled: this.disabled },
            { value: 'Spanish', htmlLabel: 'Spanish', disabled: this.disabled },
            { value: 'Other', htmlLabel: 'Other', disabled: this.disabled }
        )
        this.optionaccessibility.push(
            { value: '2', htmlLabel: 'Braille' },
            { value: '1', htmlLabel: 'Large Print' },
            { value: '4', htmlLabel: 'Audio CD' }
        )
    }

    ngOnInit() {
        this.route.params.forEach((params: Params) => {
            this.uniqueLink = this.route.snapshot.params['guid']
        })
        this.enrollmentViewModel = this._enrollmentGateway.getEnrollmentViewModel()
        if (
            this.enrollmentViewModel === undefined ||
            this.enrollmentViewModel === null ||
            this.enrollmentViewModel.UNIQUELINK === undefined ||
            this.enrollmentViewModel.UNIQUELINK === ''
        ) {
            this.enrollmentViewModel.UNIQUELINK = this.uniqueLink
        }
        this.emailLabel = 'Email Address'
        this.eobEmailLabel = ''
        this.sameAsTopAddress = false
        this.titleOptions = [
            { value: 'MR', text: 'MR' },
            { value: 'MRS', text: 'MRS' },
            { value: 'DR', text: 'DR' },
            { value: 'MS', text: 'MS' }
        ]
        //this.eobOptions = [
        //    { value: 'EEOB', htmlLabel: 'Yes, I want to receive my EOB statements electronically', disabled: this.disabled },
        //    { value: 'PEOB', htmlLabel: 'No, I want to receive my EOB statements in the mail', disabled: this.disabled }
        //]
        //this.eobOptions = [
        //    { value: '3', htmlLabel: 'Yes, I want to go paperless for all available and future documents', disabled: this.disabled },
        //    { value: 'N', htmlLabel: 'No, I want to receive all my documents in the mail', disabled: this.disabled }
        //]
        this.genderOptions = [
            { value: 'M', htmlLabel: 'M', disabled: this.disabled },
            { value: 'F', htmlLabel: 'F', disabled: this.disabled }
        ]
        this.setData()

        this.paymentOptions = [
            {
                value: 'Deduction from Social Security Check',
                htmlLabel: 'Automatic Deduction from Social Security benefit check',
                disabled: this.disabled
            },
            {
                value: 'Deduction from Railroad Retirement Board',
                htmlLabel: 'Automatic Deduction from Railroad Retirement Board benefit check',
                disabled: this.disabled
            },
            {
                value: 'Automatic Bank Draft Withdrawal',
                htmlLabel: 'Automatic Bank Draft Withdrawal from Checking or Savings Account',
                disabled: this.disabled
            },
            {
                value: 'Direct Bill',
                htmlLabel: 'Monthly payments by check',
                disabled: this.disabled
            }
        ]
    }

    ngAfterViewInit(): void {}
    //Election period start
    private getElectionPeriods(elecPeriods: BeneficiaryElectionPeriods[]) {
        this.electionPeriods = elecPeriods.map(this.buildElectionOption.bind(this))
    }

    private buildElectionOption(electionPeriods: BeneficiaryElectionPeriods): ValidatedRadioButtonModel {
        return {
            value: electionPeriods.value,
            htmlLabel: electionPeriods.text
        }
    }
    onAccessibilityChanges(value) {
        this.accessibilityValue = value
        // this.enrollment.accessibility = value;
    }

    electionPeriodChanged(period: string) {
        if (period === '' || period === undefined) {
            return
        }
        this.electionOprionsByPeriod = [] as ValidatedRadioButtonModel[]
        this.selectedOption = 'None'
        this.electedOptionCode = '0'
        this.isDateField = false
        this.selectedElectionTypes = this.enrollmentElectionTypes.filter((electionType) => electionType.ElectionTypeName === period)
        this.selectedElectionTypes.forEach((electionType) => {
            let newElectionOption = {} as ValidatedRadioButtonModel
            newElectionOption.value = electionType.ElectionTypeID.toString() // electionType.ElectionTypeReasonCode.toString()
            newElectionOption.htmlLabel = electionType.LongDescription
            newElectionOption.disabled = this.disabled
            this.electionOprionsByPeriod.push(newElectionOption)
        })
    }

    electionOptionChanged(option: string) {
        if (option === '-1' || option === undefined) {
            return
        }
        this.electedOptionCode = option
        let electionTypes = this.selectedElectionTypes.filter((electionType) => electionType.ElectionTypeID === parseInt(option))
        this.enrollmentViewModel.SELREASONCODE = electionTypes[0].ElectionTypeReasonCode

        this.isDateField = electionTypes[0].IsDateField
        this.selectedOption = this.electionOprionsByPeriod.filter((electionOption) => electionOption.value === option.toString())[0].htmlLabel
        let electionPeriodsSel = {
            value: this.electedOptionCode,
            text: this.selectedOption
        }
    }

    loadPlanList(AGENTORGID: number, planYear: string) {
        this._enrollmentGateway.getPlanList(AGENTORGID, planYear).subscribe((model: PlanList[]) => {
            this.planList = model
            this.getPlanList(this.planList)
            this.loadGenderPreference()
        })
    }

    loadGenderPreference() {
        this._enrollmentGateway.GetGenderPreferenceListForBeneficiary('ALL').subscribe((model: GenderPref[]) => {
            this.setGenderPreferenceList(model)
            this.disableData()
        })
    }

    setGenderPreferenceList(data: GenderPref[]) {
        if (data !== undefined && data !== null) {
            this.currentGender = data
                .filter((currGender) => currGender.GenderPrefListCode.toUpperCase() === 'CURRENTGENDER')
                .sort((a, b) => a.DisplayColumn - b.DisplayColumn)

            this.repYourSelf = data
                .filter((currGender) => currGender.GenderPrefListCode.toUpperCase() === 'GENDERPRONOUN')
                .sort((a, b) => a.DisplayColumn - b.DisplayColumn)

            this.currentGenderOptions = [] as ValidatedRadioButtonModel[]
            this.currentGender.forEach((gender) => {
                let newElectionOption = {} as ValidatedRadioButtonModel
                newElectionOption.value = gender.DM46Code.toString()
                newElectionOption.htmlLabel = gender.GenderPrefListDesc.toString()
                this.currentGenderOptions.push(newElectionOption)
            })
            this.repYourSelfOptions = [] as ValidatedRadioButtonModel[]
            this.repYourSelf.forEach((gender) => {
                let newElectionOption = {} as ValidatedRadioButtonModel
                newElectionOption.value = gender.DM46Code.toString()
                newElectionOption.htmlLabel = gender.GenderPrefListDesc.toString()
                this.repYourSelfOptions.push(newElectionOption)
            })
        }
    }

    disableData() {
        this.disabled = true
        this.paymentOptions.forEach((x) => (x.disabled = this.disabled))
        this.electionPeriods.forEach((x) => (x.disabled = this.disabled))
        this.electionOprionsByPeriod.forEach((x) => (x.disabled = this.disabled))
        this.genderOptions.forEach((x) => (x.disabled = this.disabled))
        this.accountTypeOptions.forEach((x) => (x.disabled = this.disabled))
        this.optionrbPresDrug.forEach((x) => (x.disabled = this.disabled))
        this.optionrbPlan.forEach((x) => (x.disabled = this.disabled))
        //this.eobOptions.forEach(x => x.disabled = this.disabled)
        this.optionrbLang.forEach((x) => (x.disabled = this.disabled))
        this.optionaccessibility.forEach((x) => (x.disabled = this.disabled))
        this.currentGenderOptions.forEach((x) => (x.disabled = this.disabled))
        this.repYourSelfOptions.forEach((x) => (x.disabled = this.disabled))
    }

    private getPlanList(planLst: PlanList[]) {
        this.optionrbPlan = planLst.map(this.buildPlanOption.bind(this))
    }

    private buildPlanOption(plan: PlanList): ValidatedRadioButtonModel {
        return {
            value: plan.PlanTypeShortName,
            htmlLabel: plan.PlanTypeName
        }
    }
    getElectionPeriod(orgId: number, planYear: string, InsuranceCo: number) {
        this._enrollmentGateway.getElectionPeriods(InsuranceCo, planYear).subscribe((model: BeneficiaryElectionPeriods[]) => {
            this.getElectionPeriods(model)
            //this.setData()

            this._enrollmentGateway.getEnrollmentElectionTypes(InsuranceCo.toString(), planYear).subscribe((model) => {
                this.enrollmentElectionTypes = model
                this.electionPeriodChanged(this.enrollmentViewModel.ELECTION)
                this.reasonCode = this.enrollmentViewModel.SEPREASONCD.toString()
                this.electionOptionChanged(this.reasonCode)
                this.loadPlanList(orgId, planYear)
            })
        })
    }
    toggle(event: any, fieldName: string) {
        if (event === 'yes') {
            this.showDet = true
        } else {
            this.showDet = false
        }
    }
    //End bene info
    setData() {
        if (this.enrollmentViewModel.UNIQUELINK !== null && this.enrollmentViewModel.UNIQUELINK !== undefined) {
            this.loading = true
            this._enrollmentGateway.getEnrollmentAppDetails(this.enrollmentViewModel.UNIQUELINK).subscribe(
                (model: EnrollmentFieldBeneficiary[]) => {
                    let currentDate = moment().format('MM/DD/YYYY')
                    for (let i = 0; i < model.length; i++) {
                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.ETHNICITY) {
                            this.enrollmentViewModel.Ethnicity = model[i].FieldValue
                        }
                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.RACE) {
                            this.enrollmentViewModel.Race = model[i].FieldValue
                        }
                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.ACCHOLDERNAME) {
                            this.enrollmentViewModel.ACCHOLDERNAME = model[i].FieldValue
                        }
                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.ELECTION) {
                            this.enrollmentViewModel.ELECTION = model[i].FieldValue
                            if (this.enrollmentViewModel.ELECTION !== undefined) {
                            }
                            //this.periodSelected = model[i].FieldValue
                        }
                        //delete
                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.RELCD) {
                            this.enrollmentViewModel.RELCD = model[i].FieldValue
                        }
                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.AGENTFN) {
                            this.enrollmentViewModel.AGENTFN = model[i].FieldValue
                        }

                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.AGENTLN) {
                            this.enrollmentViewModel.AGENTLN = model[i].FieldValue
                        }

                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.AgentSignature) {
                            this.enrollmentViewModel.AgentSignature = model[i].FieldValue
                        }
                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.PLANTYPE) {
                            this.enrollmentViewModel.PLANTYPE = model[i].FieldValue
                        }
                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.APPDT) {
                            console.log(currentDate)

                            // if (this.enrollmentViewModel.PLANYEAR !== this.planYr.toString()) {
                            // NA: 07-23-2020
                            // Removing this check for testing purpose
                            // once testing will be done, we will uncomment the below code and comment the other code
                            //if (currentDate !== this.enrollmentViewModel.APPDT) {
                            //    this.enrollmentViewModel.APPDT = currentDate
                            //} else {
                            //    this.enrollmentViewModel.APPDT = moment(model[i].FieldValue).format('MM/DD/YYYY')
                            //}
                            //}
                            this.enrollmentViewModel.APPDT = moment(model[i].FieldValue).format('MM/DD/YYYY')
                        }
                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.EFFDT) {
                            //console.log(currentDate)
                            let currDate = new Date()
                            let originalAPPDT = model.find((x) => x.FieldCode === EnrollmentFieldCodesBeneficiary.APPDT)

                            // This logic should apply only for the current AEP Period, adding the plan year check
                            let planyears = model.find((x) => x.FieldCode === EnrollmentFieldCodesBeneficiary.PLANYEAR)
                            // let SelectedPlanYear = parseInt(planyears.FieldValue)

                            // NA: 07-23-2020
                            // Removing this check for testing purpose
                            // once testing will be done, we will uncomment the below code and comment the other code
                            //if (originalAPPDT !== undefined && currentDate !== originalAPPDT.FieldValue) {
                            //    //Since new Date.getMonth() gives the month from 0 to 11 , so we have to add +1 to make it 1 to 12.
                            //    let currmonth = currDate.getMonth() + 1
                            //    if (currmonth === 11 && SelectedPlanYear > currDate.getFullYear()) {
                            //        this.enrollmentViewModel.EFFDT = moment(new Date(currDate.getFullYear() + 1, 0, 1)).format('MM/DD/YYYY')
                            //    } else {
                            //        this.enrollmentViewModel.EFFDT = moment(new Date(currDate.getFullYear(), currDate.getMonth() + 1, 1)).format('MM/DD/YYYY')
                            //    }
                            //}
                            //else {
                            //    this.enrollmentViewModel.EFFDT = moment(model[i].FieldValue).format('MM/DD/YYYY')
                            //}
                            this.enrollmentViewModel.EFFDT = moment(model[i].FieldValue).format('MM/DD/YYYY')
                        }
                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.APPFN) {
                            this.enrollmentViewModel.APPFN = model[i].FieldValue
                        }
                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.APPLN) {
                            this.enrollmentViewModel.APPLN = model[i].FieldValue
                        }
                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.SUFFIX) {
                            this.enrollmentViewModel.SUFFIX = model[i].FieldValue
                        }
                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.APPMI) {
                            this.enrollmentViewModel.APPMI = model[i].FieldValue
                        }
                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.TITLE) {
                            this.enrollmentViewModel.TITLE = model[i].FieldValue
                        }
                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.HICN) {
                            this.enrollmentViewModel.HICN = model[i].FieldValue
                        }
                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.MEDA) {
                            if (model[i].FieldValue !== undefined && model[i].FieldValue !== '') {
                                this.enrollmentViewModel.MEDA = moment(model[i].FieldValue).format('MM/DD/YYYY')
                            } else {
                                this.enrollmentViewModel.MEDA = null
                            }
                        }
                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.MEDB) {
                            if (model[i].FieldValue !== undefined && model[i].FieldValue !== '') {
                                this.enrollmentViewModel.MEDB = moment(model[i].FieldValue).format('MM/DD/YYYY')
                            } else {
                                this.enrollmentViewModel.MEDB = null
                            }
                        }
                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.APPDOB) {
                            this.enrollmentViewModel.APPDOB = moment(model[i].FieldValue).format('MM/DD/YYYY')
                        }
                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.APPPHONE) {
                            this.enrollmentViewModel.APPPHONE = model[i].FieldValue
                        }
                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.APPGEN) {
                            if (model[i].FieldValue === 'M') {
                                this.enrollmentViewModel.APPGEN = 'M'
                            } else {
                                this.enrollmentViewModel.APPGEN = 'F'
                            }
                        }
                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.CELLPHONE) {
                            this.enrollmentViewModel.CELLPHONE = model[i].FieldValue
                        }
                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.APPEMAIL) {
                            this.enrollmentViewModel.APPEMAIL = model[i].FieldValue
                            this.eobEmail = model[i].FieldValue
                            //this.enrollmentViewModel.EOB=
                        }

                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.APPADD1) {
                            this.enrollmentViewModel.APPADD1 = model[i].FieldValue
                        }
                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.APPADD2) {
                            this.enrollmentViewModel.APPADD2 = model[i].FieldValue
                        }
                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.APPCITY) {
                            this.enrollmentViewModel.APPCITY = model[i].FieldValue
                        }
                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.APPZIP) {
                            this.enrollmentViewModel.APPZIP = model[i].FieldValue
                        }
                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.APPST) {
                            this.enrollmentViewModel.APPST = model[i].FieldValue
                        }
                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.LTCFACILITY) {
                            this.enrollmentViewModel.LTCFACILITY = model[i].FieldValue
                        }
                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.LTCPHONE) {
                            this.enrollmentViewModel.LTCPHONE = model[i].FieldValue
                        }
                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.NOTES) {
                            this.enrollmentViewModel.NOTES = model[i].FieldValue
                        }
                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.SEPREASONCD) {
                            this.enrollmentViewModel.SEPREASONCD = Number(model[i].FieldValue)
                        }
                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.ELECTION) {
                            this.enrollmentViewModel.ELECTION = model[i].FieldValue
                        }
                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.MAILADD1) {
                            this.enrollmentViewModel.MAILADD1 = model[i].FieldValue
                        }
                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.MAILADD2) {
                            this.enrollmentViewModel.MAILADD2 = model[i].FieldValue
                        }
                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.MAILCITY) {
                            this.enrollmentViewModel.MAILCITY = model[i].FieldValue
                        }
                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.MAILST) {
                            this.enrollmentViewModel.MAILST = model[i].FieldValue
                        }
                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.MAILZIP) {
                            this.enrollmentViewModel.MAILZIP = model[i].FieldValue
                        }
                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.PWO) {
                            this.enrollmentViewModel.PWO = model[i].FieldValue
                        }
                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.AGENTID) {
                            this.enrollmentViewModel.AGENTID = model[i].FieldValue
                            this.agentId = Number(model[i].FieldValue)
                            this.enrollmentViewModel.ADMINID = Number(model[i].FieldValue)
                        }
                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.PLANYEAR) {
                            this.enrollmentViewModel.PLANYEAR = model[i].FieldValue

                            this.visibleFrom2025 = Number(this.enrollmentViewModel.PLANYEAR) > this._global.Planyear2024
                        }
                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.LANG) {
                            this.enrollmentViewModel.LANG = model[i].FieldValue
                        }
                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.OTHCVRG) {
                            this.enrollmentViewModel.OTHCVRG = model[i].FieldValue
                        }
                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.LANGFORMAT) {
                            this.enrollmentViewModel.EOB = model[i].FieldValue
                            this.eobOption = this.enrollmentViewModel.EOB
                            //if (this.enrollmentViewModel.EOB.toLowerCase() === 'eeob') {
                            //    this.eobEmail = 'Email Address'
                            //}

                            if (
                                this.enrollmentViewModel.EOB != undefined &&
                                this.enrollmentViewModel.EOB != null &&
                                this.enrollmentViewModel.EOB != '' &&
                                (this.enrollmentViewModel.EOB.toLowerCase() === 'eeob' ||
                                    this.enrollmentViewModel.EOB.toLowerCase() === '5' ||
                                    this.enrollmentViewModel.EOB.toLowerCase() === '6' ||
                                    this.enrollmentViewModel.EOB.toLowerCase() === '7' ||
                                    this.enrollmentViewModel.EOB.toLowerCase() === '9')
                            ) {
                                this.eobEmail = 'Email Address'
                                this.PaperlessSelected = true
                            }
                            //else {
                            //    this.eobEmail = 'Email Address (optional)'
                            //}

                            if (this.enrollmentViewModel.EOB == '1' || this.enrollmentViewModel.EOB == '5') {
                                this.accessibilityValue = '1'
                            }
                            if (this.enrollmentViewModel.EOB == '2' || this.enrollmentViewModel.EOB == '6') {
                                this.accessibilityValue = '2'
                            }
                            if (this.enrollmentViewModel.EOB == '4' || this.enrollmentViewModel.EOB == '7') {
                                this.accessibilityValue = '4'
                            }
                            if (this.enrollmentViewModel.EOB == '8' || this.enrollmentViewModel.EOB == '9') {
                                this.accessibilityValue = '8'
                            }
                        }
                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.ACCOUNTNB) {
                            this.enrollmentViewModel.ACCOUNTNB = model[i].FieldValue
                        }
                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.OTHCVRGNAME) {
                            this.enrollmentViewModel.OTHCVRGNAME = model[i].FieldValue
                        }
                        //if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.AGENTID) {
                        //    this.agentId = Number(model[i].FieldValue)
                        //}
                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.OTHCVRGID) {
                            this.enrollmentViewModel.OTHCVRGID = model[i].FieldValue
                        }
                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.OTHCVRGGRP) {
                            this.enrollmentViewModel.OTHCVRGGRP = model[i].FieldValue
                        }
                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.COBBIN) {
                            this.enrollmentViewModel.COBBIN = model[i].FieldValue
                        }
                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.COBPCN) {
                            this.enrollmentViewModel.COBPCN = model[i].FieldValue
                        }
                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.COBEFFDT) {
                            if (model[i].FieldValue !== undefined && model[i].FieldValue !== '') {
                                this.enrollmentViewModel.COBEFFDT = moment(model[i].FieldValue).format('MM/DD/YYYY')
                            } else {
                                this.enrollmentViewModel.COBEFFDT = null
                            }
                        }
                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.COBTERMDT) {
                            if (model[i].FieldValue !== undefined && model[i].FieldValue !== '') {
                                this.enrollmentViewModel.COBTERMDT = moment(model[i].FieldValue).format('MM/DD/YYYY')
                            } else {
                                this.enrollmentViewModel.COBTERMDT = null
                            }
                        }
                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.FININSTNAME) {
                            this.enrollmentViewModel.FININSTNAME = model[i].FieldValue
                        }
                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.EFTTYPE) {
                            this.enrollmentViewModel.EFTTYPE = model[i].FieldValue
                        }
                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.ROUTINGNB) {
                            this.enrollmentViewModel.ROUTINGNB = model[i].FieldValue
                        }
                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.SEPEFFDT) {
                            if (model[i].FieldValue !== undefined && model[i].FieldValue !== '') {
                                this.enrollmentViewModel.SEPEFFDT = moment(model[i].FieldValue).format('MM/DD/YYYY')
                                this.sepDate = moment(this.enrollmentViewModel.SEPEFFDT).format('MM/DD/YYYY')
                            } else {
                                this.enrollmentViewModel.SEPEFFDT = null
                                this.sepDate = ''
                            }
                        }
                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.BENEFICIARYDATE) {
                            this.enrollmentViewModel.BENEFICIARYDATE = model[i].FieldValue
                        }
                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.AUTHREPIND) {
                            this.enrollmentViewModel.AUTHREPIND = model[i].FieldValue
                        }
                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.AUTHREPNAME) {
                            this.enrollmentViewModel.AUTHREPNAME = model[i].FieldValue
                        }
                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.AUTHREPPHONE) {
                            this.enrollmentViewModel.AUTHREPPHONE = model[i].FieldValue
                        }
                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.AUTHREPREL) {
                            this.enrollmentViewModel.AUTHREPREL = model[i].FieldValue
                        }
                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.AUTHREPADD1) {
                            this.enrollmentViewModel.AUTHREPADD1 = model[i].FieldValue
                        }
                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.AUTHREPCITY) {
                            this.enrollmentViewModel.AUTHREPCITY = model[i].FieldValue
                        }
                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.AUTHREPST) {
                            this.enrollmentViewModel.AUTHREPST = model[i].FieldValue
                        }
                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.AUTHREPZIP) {
                            this.enrollmentViewModel.AUTHREPZIP = model[i].FieldValue
                        }
                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.AUTHREPADD2) {
                            this.enrollmentViewModel.AUTHREPADD2 = model[i].FieldValue
                        }
                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.AUTHREPCOPYIND) {
                            this.enrollmentViewModel.AUTHREPCOPYIND = model[i].FieldValue
                        }

                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.SOA) {
                            this.enrollmentViewModel.SOA = model[i].FieldValue
                        }
                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.PLANNAME) {
                            this.enrollmentViewModel.PLANNAME = model[i].FieldValue
                        }

                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.CUID) {
                            this.enrollmentViewModel.CUID = model[i].FieldValue
                        }

                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.CURRENTGENDER) {
                            this.enrollmentViewModel.CURRENTGENDER = model[i].FieldValue
                            if (this.enrollmentViewModel.CURRENTGENDER == '4') {
                                this.iscurrentGenderOther = true
                            }
                        }
                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.CURRENTGENDEROTH) {
                            this.enrollmentViewModel.CURRENTGENDEROTH = model[i].FieldValue
                        }
                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.GENDERNPRONOUN) {
                            this.enrollmentViewModel.GENDERNPRONOUN = model[i].FieldValue
                            if (this.enrollmentViewModel.GENDERNPRONOUN == '4') {
                                this.isyourSelfOther = true
                            }
                        }

                        if (model[i].FieldCode === EnrollmentFieldCodesBeneficiary.GENDERNPRONOUNOTH) {
                            this.enrollmentViewModel.GENDERNPRONOUNOTH = model[i].FieldValue
                        }

                        if (model[i].FieldCode === EnrollmentFieldCodes.INDREPNAME) {
                            this.enrollmentViewModel.INDREPNAME = model[i].FieldValue
                        }

                        if (model[i].FieldCode === EnrollmentFieldCodes.RELTOENROLL) {
                            this.enrollmentViewModel.RELTOENROLL = model[i].FieldValue
                        }

                        if (model[i].FieldCode === EnrollmentFieldCodes.NPN) {
                            this.enrollmentViewModel.NPN = model[i].FieldValue
                        }
                        if (model[i].FieldCode === EnrollmentFieldCodes.INDREPIND) {
                            this.enrollmentViewModel.INDREPIND = model[i].FieldValue
                        }
                    }

                    this.enrollmentViewModel.STEEREDIND = true
                    this.enrollmentViewModel.AGENTORGID = model[0].OrgID

                    if (this.enrollmentViewModel.APPADD1 === this.enrollmentViewModel.MAILADD1) {
                        this.sameAsTopAddress = true
                    }
                    this.enrollmentViewModel.INSURANCECOMPID = model[0].InsuranceCoId
                    this.enrollmentViewModel.AGENTNAME = this.enrollmentViewModel.AGENTFN + ' ' + this.enrollmentViewModel.AGENTLN
                    if (this.enrollmentViewModel.PLANYEAR != undefined && this.enrollmentViewModel.PLANYEAR != '') {
                        if (parseInt(this.enrollmentViewModel.PLANYEAR) > this._global.Planyear2024) {
                            this.optionaccessibility.push({ value: '8', htmlLabel: 'Data CD' })
                        }

                        this.setOrgname(this.enrollmentViewModel.PLANYEAR)
                    }

                    this._enrollmentGateway
                        .GetAllStatesForBeneficiary(this.enrollmentViewModel.INSURANCECOMPID)
                        .subscribe((states: ValidatedSelectOptionModel[]) => {
                            this.allStates = states
                            this.loading = false
                            this._enrollmentGateway.setEnrollmentViewModel(this.enrollmentViewModel)
                            this.getElectionPeriod(model[0].OrgID, this.enrollmentViewModel.PLANYEAR, model[0].InsuranceCoId)
                        })
                    // this.enrollmentViewModel.AgentSignature = this.enrollmentViewModel.AgentSignature
                },
                (err) => {
                    this.loading = false
                }
            )
        }
    }

    formatDate() {}

    correctionStep() {
        this._router.navigate(['/confirmation/' + this.enrollmentViewModel.UNIQUELINK + '/' + '1' + '/' + this.enrollmentViewModel.INSURANCECOMPID])
    }

    rejectStep() {
        this._router.navigate(['/confirmation/' + this.enrollmentViewModel.UNIQUELINK + '/' + '2' + '/' + this.enrollmentViewModel.INSURANCECOMPID])
    }
    continueStep() {
        this._enrollmentGateway.setEnrollmentViewModel(this.enrollmentViewModel)
        this._router.navigate(['/Step3/' + this.uniqueLink])
    }
    setOrgname(planyear: string) {
        if (Number(planyear) === this._global.CurrentYear) {
            this.orgName = 'SilverScript'
        } else {
            this.orgName = 'Aetna'
        }
    }
}
